<section class="policy-content privacy-content" appReveal>
  <div class="policy-content__inner">

    <p class="privacy-content__updated" i18n="@@privacy.updated">（2021年4月1日 最後更新）</p>

    <!-- Intro (no heading) -->
    <div class="policy-content__section" appReveal="100">
      <p class="policy-content__paragraph" i18n="@@privacy.intro.p1">「西樹泡芙」由杰甜品有限公司（下稱「西樹泡芙」）擁有及營運。西樹泡芙非常重視閣下的網上私隱權。</p>
      <p class="policy-content__paragraph" i18n="@@privacy.intro.p2">請仔細閱讀以下政策及聲明，以了解當閣下使用西樹泡芙網站或手機應用程式時，西樹泡芙如何收集和使用個人資料。</p>
      <p class="policy-content__paragraph" i18n="@@privacy.intro.p3">當閣下登入或使用西樹泡芙網站 www.chezchoux.com.hk（包括但不限於西樹泡芙外賣自取及送貨之網上訂購服務（下稱「網上訂購服務」）或其 Facebook 專頁（下稱「本網站」），即表明閣下已接受本私隱聲明之條款。如閣下不想接受下列條款的約束，請勿使用或請終止進入本網站或本應用程式。如閣下繼續使用或透過本網站或本應用程式填妥任何表格及按下「遞交」鈕，即表明閣下已詳細閱讀及瞭解本私隱聲明，並同意本私隱聲明中所敍述及日後西樹泡芙所實行的資料收集和使用方法。西樹泡芙保留權利可隨時更新及更改本網站或本應用程式內容，並可單方面修改本私隱聲明而不另作通知。閣下應定期透過本網站或本應用程式查看本私隱聲明是否有所修改，因爲閣下對本網站或本應用程式的持續使用即表明閣下接受本私隱聲明的任何變更。</p>
      <p class="policy-content__paragraph" i18n="@@privacy.intro.p4">如果本私隱聲明有任何的修改可能會對我們使用或者披露閣下的資料（包括閣下的個人資料）（下稱「資料」）的方式產生極大影響，西樹泡芙會在取得閣下同意後才將閣下資料作有關用途。在此，「閣下」和「用戶」乃指以任何理由或目的進入本網站或本應用程式之所有個別人士。</p>
    </div>

    <hr class="policy-content__divider">

    <!-- 收集個人資料的政策 -->
    <div class="policy-content__section" appReveal="100">
      <h2 class="policy-content__heading font-display" i18n="@@privacy.collectionPolicy.heading">收集個人資料的政策</h2>
      <ul class="policy-content__list">
        <li class="policy-content__list-item" i18n="@@privacy.collectionPolicy.item1">閣下在享用西樹泡芙訂購服務或西樹泡芙電子服務時，需要自願及不時向西樹泡芙提供足夠但不超乎適度的個人資料。如閣下未能向西樹泡芙提供或更新其個人資料，西樹泡芙可能無法向閣下提供服務。</li>
        <li class="policy-content__list-item" i18n="@@privacy.collectionPolicy.item2">閣下必須通知西樹泡芙其最新的個人資料，西樹泡芙將不會就閣下未能通知有關更改而引致的任何損失承擔任何責任。</li>
        <li class="policy-content__list-item" i18n="@@privacy.collectionPolicy.item3">西樹泡芙將會採取所有合理切實可行的方法，以確保個人資料受到保障，不會在未經許可或意外的情況下被查閱、處理、刪除或作其他用途，並確保閣下可以獲悉西樹泡芙所持有的個人資料的種類以及主要用途。</li>
        <li class="policy-content__list-item" i18n="@@privacy.collectionPolicy.item4">西樹泡芙對於收集、使用、保存、披露、移轉、保護及存取個人資料的政策和做法，均遵照條例規定的責任及要求，包括個人資料（私隱）條例。</li>
      </ul>
    </div>

    <hr class="policy-content__divider">

    <!-- 保存個人資料的目的 -->
    <div class="policy-content__section" appReveal="100">
      <h2 class="policy-content__heading font-display" i18n="@@privacy.retention.heading">保存個人資料的目的</h2>
      <p class="policy-content__paragraph" i18n="@@privacy.retention.p1">個人資料只供作有關資料收集時擬作的用途，除非閣下明確表示同意其個人資料可改作其他用途，又或此等用途是香港特別行政區的法例或法律所容許或要求的，則當別論。</p>
      <p class="policy-content__paragraph" i18n="@@privacy.retention.p2">西樹泡芙將不會保存個人資料超過將其保存以貫徹該等資料被使用或會被使用的目的（包括任何直接有關的目的）所需的時間。</p>
    </div>

    <hr class="policy-content__divider">

    <!-- 收集個人資料的用途 -->
    <div class="policy-content__section" appReveal="100">
      <h2 class="policy-content__heading font-display" i18n="@@privacy.usage.heading">收集個人資料的用途</h2>
      <p class="policy-content__paragraph" i18n="@@privacy.usage.intro">當閣下使用本網站、本應用程式或西樹泡芙電子服務、更新閣下的資料、提交查詢及/或使用其他由本網站、本應用程式或西樹泡芙電子服務提供之服務，可能須向西樹泡芙提供閣下的資料，包括但不限於姓名、聯絡資料、電郵地址及 Facebook 賬號。閣下同意此等資料是閣下自願向西樹泡芙提供的。閣下同意及明白向西樹泡芙提供的任何及所有資料將被收集並可作以下用途：</p>
      <ul class="policy-content__list">
        <li class="policy-content__list-item" i18n="@@privacy.usage.item1">使用訂購服務，作身份核證及紀錄；</li>
        <li class="policy-content__list-item" i18n="@@privacy.usage.item2">向閣下提供我們及其有關機構的定期信息，包括但不限產品、優惠及聯合推廣資訊；</li>
        <li class="policy-content__list-item" i18n="@@privacy.usage.item3">與閣下溝通；</li>
        <li class="policy-content__list-item" i18n="@@privacy.usage.item4">本公司、代理、承辦商等之任何產品／或服務之推廣和宣傳；</li>
        <li class="policy-content__list-item" i18n="@@privacy.usage.item5">將閣下的資料例如個人資料、消費及優惠下載記錄等進行數據排序及分析，使西樹泡芙能了解閣下的特點及購買行為，向閣下提供更符合閣下需要的服務和執行閣下之指示及申請、處理查詢及投訴；</li>
        <li class="policy-content__list-item" i18n="@@privacy.usage.item6">進行客戶、產品及服務調查；</li>
        <li class="policy-content__list-item" i18n="@@privacy.usage.item7">設計西樹泡芙或參與商戶提供的新服務，或改善現有服務；</li>
        <li class="policy-content__list-item" i18n="@@privacy.usage.item8">處理訂單、付款（包括直接於賬戶內扣減優惠或轉至有關系統之付款指示）以及各類服務要求；</li>
        <li class="policy-content__list-item" i18n="@@privacy.usage.item9">當閣下使用本網站、本應用程式及其它電子服務時處理及顯示閣下的資料；</li>
        <li class="policy-content__list-item" i18n="@@privacy.usage.item10">本政策以外任何閣下及本公司之間可能同意的目的；</li>
        <li class="policy-content__list-item" i18n="@@privacy.usage.item11">根據本公司需遵守的條例要求作出披露及任何與上述有直接關連之事項。</li>
      </ul>
      <p class="policy-content__paragraph" i18n="@@privacy.usage.outro">西樹泡芙將使用閣下之資料包括（但並不止於）姓名、通訊地址、電郵地址、Facebook 賬號、手提電話號碼、八達通號碼、出生日期、惠顧次數及金額、賬單的資料，以及為提供本公司各項服務所需的其他資料。閣下必須提供閣下的個人資料作以上用途。否則，西樹泡芙將不能完成閣下的訂購服務、提供推廣優惠及提供相關的西樹泡芙服務。</p>
    </div>

    <hr class="policy-content__divider">

    <!-- 直接促銷 -->
    <div class="policy-content__section" appReveal="100">
      <h2 class="policy-content__heading font-display" i18n="@@privacy.marketing.heading">直接促銷</h2>
      <p class="policy-content__paragraph" i18n="@@privacy.marketing.intro">西樹泡芙會使用閣下的資料以達到以下直接促銷的用途（無論通過郵件、電郵、電話、手機短訊、短訊或類似形式）：</p>
      <ul class="policy-content__list">
        <li class="policy-content__list-item" i18n="@@privacy.marketing.item1">有關由西樹泡芙提供的店內活動及由西樹泡芙提供的服務及產品的最新消息、優惠、推廣、現金券及優惠券；</li>
        <li class="policy-content__list-item" i18n="@@privacy.marketing.item2">西樹泡芙的合作夥伴提供的服務及產品的最新消息、優惠、推廣、現金券及優惠券，包括旅遊及酒店、餐飲、娛樂、主題公園、戲院、服裝、食品、飲品、飲食服務、教育、交通、家庭電器、電子產品、電腦及配件、傢俬及家居用品、影音產品、文儀玩具、嬰兒用品、健康護理產品、時裝、飾物、皮具及行李、鞋履、鐘錶及珠寶、美髮產品、美容用品及化妝品、寵物用品、媒體、物流、商場、課程、會籍、金融、保險、銀行、信用卡、電訊產品及服務、電子商務（包括交易及付款平台及網上拍賣）及其他消費類產品及服務。</li>
      </ul>
      <p class="policy-content__paragraph" i18n="@@privacy.marketing.p2">除非得到閣下的同意，否則西樹泡芙將不會使用閣下的個人資料。所有有關市場推廣的資訊只會由西樹泡芙或西樹泡芙的代理人發出，並不會由西樹泡芙以外的其他機構發出。</p>
      <p class="policy-content__paragraph" i18n="@@privacy.marketing.p3">閣下可於辦公時間內致電西樹泡芙客戶服務熱線 <span class="policy-content__label">2690 1853</span> 要求西樹泡芙停止使用閣下的個人資料作直接促銷用途，閣下亦可以登入香港西樹泡芙網頁 www.chezchoux.com.hk 通知我們或西樹泡芙訂購應用程式作出更改。西樹泡芙將不會收取費用並於合理時間內停止使用閣下的個人資料作直接促銷用途。</p>
      <p class="policy-content__paragraph" i18n="@@privacy.marketing.p4">如果閣下選擇不接收西樹泡芙發送的直接促銷資訊，西樹泡芙依然會向閣下發送有關西樹泡芙的資料及與西樹泡芙服務相關的非宣傳資訊，包括但不限於戶口狀態、訂單狀態及訊息、行政安排等，而閣下有義務及責任接收及閱覽該等資訊。</p>
    </div>

    <hr class="policy-content__divider">

    <!-- 個人資料的披露及轉移 -->
    <div class="policy-content__section" appReveal="100">
      <h2 class="policy-content__heading font-display" i18n="@@privacy.disclosure.heading">個人資料的披露及轉移</h2>
      <p class="policy-content__paragraph" i18n="@@privacy.disclosure.intro">西樹泡芙尊重及關心閣下對個人私隱的重視，因此會對西樹泡芙所持有的個人資料予以保密。閣下明白、同意及授權西樹泡芙把閣下所提供之資料保留及儲存西樹泡芙及/或其關聯公司的服務器上，這些信息和資料可能傳送至香港或香港以外的地方，並將此等資料提供、披露、供存取及傳送予：</p>
      <ul class="policy-content__list">
        <li class="policy-content__list-item" i18n="@@privacy.disclosure.item1">西樹泡芙及其關聯公司授權為上述收集資料目的處理有關資料之僱員；西樹泡芙業務運作有關的類似服務的第三方服務提供者及其代理人及承辦商；西樹泡芙與所有受聘用的第三方服務提供者經已簽訂保密責任契約；於保密責任契約協訂下，第三方服務提供者只限把閣下的資料用於執行西樹泡芙所委托的服務上。</li>
        <li class="policy-content__list-item" i18n="@@privacy.disclosure.item2">根據法律或其他法定機構發出的指引，西樹泡芙需向該人士履行披露責任。</li>
      </ul>
    </div>

    <hr class="policy-content__divider">

    <!-- 個人資料的安全 -->
    <div class="policy-content__section" appReveal="100">
      <h2 class="policy-content__heading font-display" i18n="@@privacy.security.heading">個人資料的安全</h2>
      <p class="policy-content__paragraph" i18n="@@privacy.security.p1">西樹泡芙不能保證互聯網的數據資料傳輸是百分之百可靠。西樹泡芙會運用各種實際可行的安全技術和程序來保障閣下的個人資料免受第三方干擾。但閣下必須清楚知道在本網站、本應用程式或其他西樹泡芙電子服務上設有鏈路的其他網站可能在收集你的個人資料。閣下向第三者提供的資料均與西樹泡芙無關，西樹泡芙概不承擔任何責任。</p>
    </div>

    <hr class="policy-content__divider">

    <!-- 個人資料的查詢及更新 -->
    <div class="policy-content__section" appReveal="100">
      <h2 class="policy-content__heading font-display" i18n="@@privacy.access.heading">個人資料的查詢及更新</h2>
      <p class="policy-content__paragraph" i18n="@@privacy.access.rightsIntro">閣下有權：</p>
      <ul class="policy-content__list">
        <li class="policy-content__list-item" i18n="@@privacy.access.right1">查核西樹泡芙是否持有閣下的個人資料紀錄；</li>
        <li class="policy-content__list-item" i18n="@@privacy.access.right2">查閱西樹泡芙持有閣下的個人資料紀錄；</li>
        <li class="policy-content__list-item" i18n="@@privacy.access.right3">更改閣下任何不正確的個人資料紀錄；</li>
        <li class="policy-content__list-item" i18n="@@privacy.access.right4">確定西樹泡芙就個人資料（不時）採取的政策及常規；</li>
        <li class="policy-content__list-item" i18n="@@privacy.access.right5">隨時要求不再收到西樹泡芙發出的直接宣傳資料；</li>
        <li class="policy-content__list-item" i18n="@@privacy.access.right6">八達通一經登記，只能更改，不可移除。</li>
      </ul>
      <p class="policy-content__paragraph" i18n="@@privacy.access.contactIntro">如欲提出任何上述的要求或對西樹泡芙的個人私隱之陳述有任何查詢，可透過以下方法與西樹泡芙的客戶服務部聯絡。請註明閣下之姓名、聯絡電話。</p>

      <div class="policy-content__callout">
        <p class="policy-content__callout-line"><span class="policy-content__label" i18n="@@privacy.access.callout.email.label">電郵至：</span>order@chouxcreme.com.hk</p>
        <p class="policy-content__callout-line"><span class="policy-content__label" i18n="@@privacy.access.callout.mail.label">郵寄至：</span><ng-container i18n="@@privacy.access.callout.mail.address">香港沙田火炭坳背灣街 2-12 號威力工業中心 7 樓 M 室</ng-container></p>
        <p class="policy-content__callout-line"><span class="policy-content__label" i18n="@@privacy.access.callout.hotline.label">客戶服務熱線：</span>26901853</p>
        <p class="policy-content__callout-note" i18n="@@privacy.access.callout.hours">辦公時間：星期一至五 上午九時至中午十二時三十分及下午二時至六時；星期六、星期日及公眾假期休息</p>
      </div>

      <p class="policy-content__paragraph" i18n="@@privacy.access.fee">根據有關條例，西樹泡芙有權對查閱個人資料的要求收取合理的處理費用。</p>
    </div>

    <hr class="policy-content__divider">

    <!-- 兒童 -->
    <div class="policy-content__section" appReveal="100">
      <h2 class="policy-content__heading font-display" i18n="@@privacy.children.heading">兒童</h2>
      <p class="policy-content__paragraph" i18n="@@privacy.children.p1">本網站或本應用程式沒計劃或意圖獲取年齡在 18 歲以下的未成年人士（"未成年人士"）的個人資料。爲尊重未成年人士的私隱權，未成年人士不應在本網站或本應用程式提供任何個人資料。西樹泡芙要求兒童在本網站或使用本應用程式時應由父母進行監督。</p>
    </div>

  </div>
</section>
